import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hostKYC: {
    isAdharVerified: false,
  },
  hostBasicDetails: {},
  hostProfileDetails: {},
};

const hostForm = createSlice({
  name: "hostForm",
  initialState,
  reducers: {
    updateHostState: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        if (key in state && typeof state[key as keyof typeof state] === "object") {
          state[key as keyof typeof state] = {
            ...state[key as keyof typeof state],
            ...action.payload[key],
          };
        }
      });
    },
    updateHostKyc: (state, action) => {
      // Merge the new details with the existing ones
      state.hostKYC = {
        ...state.hostKYC,
        ...action.payload,
        isAdharVerified: action.payload.hasOwnProperty("isAdharVerified")
          ? action.payload.isAdharVerified
          : false,
      };
    },
    updateHostBasicDetails: (state, action) => {
      state.hostBasicDetails = {
        ...state.hostBasicDetails,
        ...action.payload,
      };
    },
    updateHostProfileDetails: (state, action) => {
      state.hostProfileDetails = action.payload;
    },
    // Reset Actions
    resetHostKYC: (state) => {
      state.hostKYC = {
        ...initialState.hostKYC, // Reset to initial values
        isAdharVerified: false,
      };
    },
    resetHostBasicDetails: (state) => {
      state.hostBasicDetails = initialState.hostBasicDetails;
    },
    resetHostProfileDetails: (state) => {
      state.hostProfileDetails = initialState.hostProfileDetails;
    },
    resetAll: () => initialState,
  },
});

export const {
  updateHostKyc,
  updateHostBasicDetails,
  updateHostProfileDetails,
  resetHostKYC,
  resetHostBasicDetails,
  resetHostProfileDetails,
  resetAll,
  updateHostState
} = hostForm.actions;

export default hostForm.reducer;
